<template>
    <div id="StepsFirst">
        <a-spin :spinning="buttonLoading.spinning">
            <a-form-model :model="form.data"
                          ref="stepsFirstRuleForm"
                          :rules="form.rules"
                          :label-col="{ span: 6 }"
                          :wrapper-col="{ span: 15 }">
                <a-form-model-item label="课程名称" prop="name">
                    <a-input v-model="form.data.name" :maxLength="35" placeholder="请输入"/>
                </a-form-model-item>
                <a-form-model-item label="课程资源" :class="!courseInfo && 'access-resources'"
                                   prop="projectCourseResourceName">
                    <div @click="selectResourcesGetPageList(1)"
                         :style="courseInfo ? 'pointer-events:none;' : 'cursor: pointer;'">
                        <a-input v-model="form.data.projectCourseResourceName" placeholder="请选择" class="pointer">
                            <span v-if="!courseInfo" slot="suffix"
                                  class="ant-btn-link">
                                点击选择
                            </span>
                        </a-input>
                    </div>
                </a-form-model-item>
                <a-form-model-item label="课程码类型" prop="codeType">
                    <a-radio-group v-model="form.data.codeType"
                                   :disabled="complete || otherStatus">
                        <a-radio :value="3">学生码</a-radio>
                        <a-radio :value="1">班级码</a-radio>
                        <a-radio :value="0">无课程码</a-radio>
                    </a-radio-group>
                    <a-popover placement="bottom">
                        <template slot="content">
                            <p style="white-space: nowrap;">无课程码：以学生关联手机号登录使用</p>
                            <p style="white-space: nowrap;">班级码：以班级码登录使用，每个班级一个课程码</p>
                            <p style="white-space: nowrap;">学生码：以学生码登录使用，每个学生一个课程码</p>
                        </template>
                        <a-button type="link">类型说明</a-button>
                    </a-popover>
                </a-form-model-item>
                <a-form-model-item label="开课规则">
                    <a-button @click="openClassClick" class="setting-btn">设置规则</a-button>
                </a-form-model-item>
                <a-form-model-item label="开始时间" prop="effectiveDate">
                    <!--                    <a-date-picker v-model="form.data.effectiveDate" style="width: 100%;" :disabled="complete"-->
                    <a-date-picker v-model="form.data.effectiveDate" style="width: 100%;"
                                   @change="effectiveDateChange" show-time
                                   :disabled-date="current => current && (current < (new Date().getTime() - 86400000))"
                                   valueFormat/>
                </a-form-model-item>
                <a-form-model-item label="结束时间" prop="uneffectiveDate">
                    <!--                    <a-date-picker v-model="form.data.uneffectiveDate" style="width: 100%;" :disabled="complete"-->
                    <a-date-picker v-model="form.data.uneffectiveDate" style="width: 100%;" show-time
                                    @openChange="closepicker"
                                    @ok="uneffectiveDateChange"
                                   :disabled-date="current => current && (current < (new Date(form.data.effectiveDate).getTime() - 86400000) || current < Date.now() - 86400000)"
                                   format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss"/>
                </a-form-model-item>
                <a-form-model-item label="备注">
                    <a-input v-model="form.data.description" :maxLength="50" type="textarea"/>
                </a-form-model-item>
            </a-form-model>
            <div style="text-align: center;">
                <a-button :loading="buttonLoading.prev" @click="preserveAndOut" type="primary" ghost
                          style="margin-right: 50px;">
                    保存并退出
                </a-button>
                <a-button :loading="buttonLoading.next" @click="preserveAndOut(1)" type="primary">
                    下一步 配置学生
                </a-button>
            </div>
        </a-spin>

        <a-modal title="选择资源"
                 width="1100px"
                 v-model="selectResources.visible"
                 @ok="selectResourcesModalOk"
                 @cancel="selectResourcesModalCancel">
            <a-spin :spinning="selectResourcesTableRelevant.tableLoading">
                <div style="height: 400px;overflow-y: auto">
                    <a-form-model layout="inline" :model="selectResources.searchForm">
                        <a-form-model-item label="资源名称">
                            <a-input class="serach-item" :maxLength="30" allowClear
                                     v-model="selectResources.searchForm.courseName"
                                     placeholder="请输入资源名称"/>
                        </a-form-model-item>
                        <a-form-model-item label="学段">
                            <a-select class="serach-item" allowClear v-model="selectResources.searchForm.period"
                                      placeholder="请选择状态">
                                <a-select-option :key="item" :value="item" v-for="item in $data._period">
                                    {{ item }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item style="margin-right: 35px;">
                            <a-button @click="selectResourcesGetPageList(1)" type="primary" html-type="button">
                                查询
                            </a-button>
                        </a-form-model-item>
                    </a-form-model>
                    <div class="content-box">
                        <div v-if="selectResourcesTableRelevant.tableDataSource.length <= 0"
                             class="ant-empty ant-empty-normal">
                            <div class="ant-empty-image">
                                <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(0 1)" fill="none" fillRule="evenodd">
                                        <ellipse fill="#F5F5F5" cx="32" cy="33" rx="32" ry="7"></ellipse>
                                        <g fillRule="nonzero" stroke="#D9D9D9">
                                            <path
                                                d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                                            <path
                                                d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                                                fill="#FAFAFA"></path>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <p class="ant-empty-description">暂无数据</p></div>
                        <ResourcesItem
                            :class="selectResources.active === index && 'resourcesItemActive'"
                            :resource-data="item"
                            :key="item.id"
                            v-for="(item, index) in selectResourcesTableRelevant.tableDataSource"
                            @click.native="selectResources.active = index">
                        </ResourcesItem>
                    </div>
                    <div v-if="selectResourcesTableRelevant.tablePagination.total > 0">
                        <a-pagination style="float: right;"
                                      showLessItems
                                      showSizeChanger
                                      showQuickJumper
                                      :showTotal="selectResourcesTableRelevant.tablePagination.showTotal"
                                      :total="selectResourcesTableRelevant.tablePagination.total"
                                      :pageSize="selectResourcesTableRelevant.tablePagination.pageSize"
                                      :current="selectResourcesTableRelevant.tablePagination.current"
                                      @change="selectResourcesTableRelevant.tablePagination.onChange"
                                      @showSizeChange="selectResourcesTableRelevant.tablePagination.onShowSizeChange"/>
                    </div>
                </div>
            </a-spin>
        </a-modal>

        <!--开课规则-->
        <a-modal title="开课规则"
                 width="1200px"
                 v-model="openClass.visible"
                 :confirm-loading="openClass.confirmLoading"
                 @ok="openClassModalOk"
                 @cancel="openClassModalCancel">
            <a-table :columns="openClassColumns"
                     :rowKey="(text, index) => ''+text.id+index"
                     :loading="openClassTableRelevant.tableLoading"
                     :scroll="{ y: 300 }"
                     size="middle"
                     :pagination="openClassTableRelevant.tablePagination"
                     :data-source="openClassTableRelevant.tableDataSource">
                <a-icon slot="filterIcon" type="filter" theme="filled"
                        :style="{pointerEvents: openClass.isCourseDisabled && 'none'}"/>
                <div v-show="!complete" slot="filterDropdown" slot-scope="{ clearFilters }" style="padding: 8px">
                    <a-radio-group v-model="openClass.tableHeadRadioValue"
                                   style="border-bottom: 1px solid #dcdcdc;padding-bottom: 7px;">
                        <a-radio v-for="item in openClassSelectVal" :key="item.ruleType"
                                 class="openClass-tableHead-radio"
                                 :value="item.ruleType">
                            {{ item.name }}
                        </a-radio>
                    </a-radio-group>
                    <a-button type="link" style="display: block;width: 100%;" size="small"
                              @click="() => openClassTableRadioClick(clearFilters)">
                        确定
                    </a-button>
                </div>
                <span slot="ruleType" slot-scope="text, record"
                      :style="{pointerEvents: openClass.isCourseDisabled && 'none'}">
                    <a-select v-model="openClassTableRelevant.tableDataSource[record.index].ruleType"
                              style="width: 180px" :disabled="complete"
                              @change="openClassSettingSelectChange(openClassTableRelevant.tableDataSource[record.index])">
                        <a-select-option :value="item.ruleType" :key="item.ruleType"
                                         v-for="item in openClassSelectVal">
                          {{ item.name }}
                        </a-select-option>
                    </a-select>
                </span>
                <div slot="ruleValue" slot-scope="text, record" class="setting-table-td"
                     :style="{pointerEvents: openClass.isCourseDisabled && 'none'}">
                    <a-tooltip v-if="record.ruleType === 2" placement="topLeft" title="最长延迟时间为60天">
                        <a-input-number v-model="openClassTableRelevant.tableDataSource[record.index].day"
                                        :style="{width: '180px'}" type="number"
                                        :min="1"
                                        :disabled="complete"
                                        :max="60"
                                        :formatter="value => /^[0-9]*$/.test(value) ? value : ''"
                                        placeholder="请输入延迟天数"/>
                    </a-tooltip>
                    <a-date-picker v-model="openClassTableRelevant.tableDataSource[record.index].time"
                                   v-else-if="record.ruleType === 3"
                                   format="YYYY-MM-DD HH:mm:ss"
                                   show-time
                                   :disabled="complete"
                                   :disabled-date="current => current && current < Date.now() - 86400000"
                                   :style="{width: '180px',minWidth: '180px'}"
                                   placeholder="请选择开课时间"/>
                    <a-range-picker v-else-if="record.ruleType === 5" :placeholder="['请选择开始时间', '请选择结束时间']"
                                    :getPopupContainer="triggerNode => triggerNode.parentNode"
                                    v-model="openClassTableRelevant.tableDataSource[record.index].range"
                                    valueFormat="YYYY-MM-DD HH:mm:ss" show-time
                                    :disabled-date="current => current && current < Date.now() - 86400000"/>
                    <a-input v-else style="width: 180px;" disabled/>
                </div>
            </a-table>
        </a-modal>
    </div>
</template>

<script>
import {tableRelevant, FormatDate} from '@/pages/projectImpl/js/utils'
import ResourcesItem from '@/pages/projectImpl/courseManage/components/ResourcesItem.vue'

const openClassSelectVal = [
    {
        name: '默认开课',
        ruleType: 0
    }, {
        name: '依次开课',
        ruleType: 1
    }, {
        name: '延迟天数开课',
        ruleType: 2
    }, {
        name: '定时开课',
        ruleType: 3
    }, {
        name: '付费开课',
        ruleType: 4
    }, {
        name: '限期开课',
        ruleType: 5
    }
]

const openClassColumns = [
    {
        title: '课时名称',
        dataIndex: 'childCourseName',
        key: '1'
    },
    {
        title: '类型',
        dataIndex: 'ruleType',
        key: '2',
        scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'ruleType'
        }
    },
    {
        title: '延迟天数/开课时间',
        dataIndex: 'ruleValue',
        scopedSlots: {customRender: 'ruleValue'},
        key: '3'
    }
]

export default {
    name: 'StepsFirst',
    components: {ResourcesItem},
    data() {
        return {
            courseInfo: this.$store.getters["organization/getCourseInfo"](),
            organizationId: this.$store.getters["organization/getOrganizationInfo"]().id,
            form: {
                productList: [], //测评类型选项
                data: {
                    name: '', //测评名称
                    courseId: undefined,
                    projectCourseResourceId: undefined,
                    projectCourseResourceName: '', //选择的资源名称
                    effectiveDate: undefined, // 开始时间
                    uneffectiveDate: undefined, // 结束时间
                    assessTypeTime: undefined, //测评类型过期时间
                    assessTypeStatus: true, //测评类型是否启用
                    assessTypeName: undefined, //测评类型名称
                    codeType: 3, //课程码类型
                    deblockRules: [], //开课规则
                    description: '', //备注
                    codeTypeDisabled: false

                },
                rules: {
                    name: [{required: true, message: '请输入', trigger: 'blur'}],
                    projectCourseResourceName: [{required: true, message: '请选择', trigger: 'change'}],
                    effectiveDate: [{required: true, message: '请选择开始时间', trigger: 'change'}],
                    uneffectiveDate: [{required: true, message: '请选择结束时间', trigger: 'change'}],
                    codeType: [{required: true, message: '请选择课程码类型', trigger: 'change'}]
                }
            },
            //页面loading
            buttonLoading: {
                spinning: false,
                prev: false,
                next: false
            },
            // 选择资源相关
            selectResourcesTableRelevant: tableRelevant.call(this, this.selectResourcesGetPageList),
            selectResources: {
                visible: false,
                active: -1,
                searchForm: {
                    courseName: '',
                    ProductServiceIds: [],
                    period: undefined
                }
            },
            // 开课规则相关
            openClassSelectVal,
            openClassColumns,
            openClassTableRelevant: tableRelevant.call(this),
            openClassTableDataCache: [], //开课规则表格数据缓存
            openClass: {
                visible: false,
                confirmLoading: false,
                isCourseDisabled: false,
                tableHeadRadioValue: 0,
                courseId: ''
            },
            complete: false,//是否为已完成
            otherStatus: false,//其他状态
        }
    },
    mounted() {
        this.initEditData()
    },
    methods: {
        //初始化编辑时页面数据
        initEditData() {
            if (this.courseInfo) {
                const data = this.courseInfo
                this.complete = this.$route.query.statusName == '已完成'
                this.otherStatus = this.$route.query.statusName !== '已完成'
                this.form.data.projectCourseResourceName = data.courseResourceName
                this.form.data.projectCourseResourceId = data.projectCourseResourceId
                this.form.data.courseId = data.courseId
                this.form.data.assessTypeName = data.productServiceName
                this.form.data.name = data.name
                this.form.data.codeType = data.codeType
                this.form.data.description = data.description
                this.form.data.codeTypeDisabled = data.configuredUserCount > 0
                this.form.data.effectiveDate = data.effectiveDate
                this.form.data.uneffectiveDate = data.uneffectiveDate
                this.buttonLoading.spinning = true
                this.getOpenClassTableData().then(() => {
                    this.buttonLoading.spinning = false
                    const assessType = this.form.productList.filter(f => f.productServiceId === this.form.data.assessType)[0]
                    if (assessType) {
                        // this.form.data.assessTypeNumber = assessType.remainingAvailableTimes
                        this.form.data.assessTypeTime = assessType.effectiveDate
                        this.form.data.assessTypeStatus = assessType.status
                            && new Date().getTime() < new Date(assessType.effectiveDate).getTime()
                    }
                })
            }
        },
        // 选择资源 - 获取资源列表
        selectResourcesGetPageList(pageIndex) {
            // if (!this.form.data.assessTypeNumber) {
            //     return
            // }
            if (pageIndex) {
                this.selectResources.visible = true
            }
            const params = {
                organizationId: this.courseInfo.organizationId,
                pageIndex: pageIndex || this.selectResourcesTableRelevant.tablePagination.current,
                pageSize: this.selectResourcesTableRelevant.tablePagination.pageSize,
                courseType: this.courseInfo.courseType,
                ...this.selectResources.searchForm
            }
            const urlArr = []
            for (let key in params) {
                if (params[key]) {
                    if (Array.isArray(params[key])) {
                        params[key].forEach(f => {
                            urlArr.push(key + '=' + f)
                        })
                    } else {
                        urlArr.push(key + '=' + params[key])
                    }
                }
            }
            // let url = Apis.AccessResources.getResourcesList + '?' + urlArr.join('&')
            this.selectResourcesTableRelevant.tableLoading = true
            // this.$http.get(url).then(({ status, data, message }) => {
            this.$http.CourseService.getCourseResources(params).then(res => {
                const {status, data, message} = res;
                this.selectResourcesTableRelevant.tableLoading = false
                this.selectResourcesTableRelevant.tableDataSource = data.items
                this.selectResourcesTableRelevant.tablePagination.total = data.totalCount
                this.selectResourcesTableRelevant.tablePagination.current = data.pageIndex

            })
        },
        // 选择资源 - 弹框点击确认
        selectResourcesModalOk() {
            this.$message.destroy()
            if (this.selectResources.active === -1) {
                this.$message.warn('请选择资源')
                return
            }
            const json = this.selectResourcesTableRelevant.tableDataSource[this.selectResources.active]
            this.selectResources.visible = false
            this.form.data.projectCourseResourceId = json.id
            this.form.data.courseId = json.courseId
            this.form.data.projectCourseResourceName = json.courseName
            this.selectResources.active = -1
            this.$refs.stepsFirstRuleForm.clearValidate('projectCourseResourceName')
            this.getOpenClassTableData()
            sessionStorage.setItem('StepsFirstCourseResource', JSON.stringify(json))
        },
        // 选择资源 - 弹框点击取消
        selectResourcesModalCancel() {
            this.selectResources.active = -1
        },


        //点击开课规则
        openClassClick() {
            this.$refs.stepsFirstRuleForm.validateField('projectCourseResourceName', msg => {
                if (!msg) {
                    this.openClass.visible = true
                }
            })
        },
        //开课规则 - 获取表格数据
        getOpenClassTableData() {
            return new Promise((resolve, reject) => {
                let params = {
                    pageIndex: this.openClassTableRelevant.tablePagination.current,
                    pageSize: 9999,
                    courseId: this.form.data.courseId,
                }
                if (this.courseInfo) {
                    params.ProjectCourseConfigId = this.courseInfo.id
                }
                this.openClassTableRelevant.tableLoading = true
                // this.$http.get(Apis.GetChildcourseDeblockRulePageList, { params }).then(({ status, data, message }) => {
                this.$http.Course.addCourseCourseResourceSetting(params).then(res => {
                    const {data} = res;
                    this.openClassTableRelevant.tableLoading = false
                    this.openClassTableRelevant.tablePagination.total = data.totalCount
                    this.openClassTableRelevant.tableDataSource = data.map((v, i) => {
                        let ruleValue = v.ruleValue;
                        if (v.ruleType === 5) {
                            let ruleValueJson = JSON.parse(v.ruleValue);
                            ruleValue = [ruleValueJson.effectiveTime, ruleValueJson.uneffectiveTime]
                        }
                        return {
                            ...v,
                            index: i,
                            day: v.ruleType === 2 ? ruleValue : '',
                            time: v.ruleType === 3 ? ruleValue : null,
                            range: v.ruleType === 5 ? ruleValue : [],
                        }
                    })
                    this.openClassModalOk(1)
                    resolve()
                }).catch(e => {
                  if (e.message === '课程名称已存在') {
                    this.$message.error('测评名称已存在')
                  } else {
                    this.$message.error(e.message)
                  }
                  reject(e.message)
                })
            })
        },
        //开课规则 - 弹框点击确定
        openClassModalOk(type) {
            this.$message.destroy()
            let arr = []
            for (let i = 0; i < this.openClassTableRelevant.tableDataSource.length; i++) {
                let v = this.openClassTableRelevant.tableDataSource[i]
                let ruleValue = ''
                let input = document.querySelectorAll('.setting-table-td')[i]
                switch (v.ruleType) {
                    case 2:
                        if (input) {
                            input.querySelector('.ant-input-number').style.borderColor = '#d9d9d9'
                        }
                        ruleValue = v.day
                        if (!ruleValue) {
                            this.$message.error('请输入延迟天数')
                            if (input) {
                                input.querySelector('.ant-input-number').style.borderColor = '#d90a04'
                            }

                            return
                        }
                        break
                    case 3:
                        if (input) {
                            input.querySelector('input').style.borderColor = '#d9d9d9'
                        }
                        if (v.time !== null && typeof v.time === 'object') {
                            ruleValue = v.time.format('YYYY-MM-DD HH:mm:ss')
                        } else {
                            ruleValue = v.time
                        }
                        if (!ruleValue) {
                            if (input) {
                                input.querySelector('input').style.borderColor = '#d90a04'
                            }
                            this.$message.error('请选择开课时间')
                            return
                        }
                        break
                    case 5:
                        if (v.range && v.range.length){
                            ruleValue = JSON.stringify({
                                effectiveTime: v.range[0],
                                uneffectiveTime: v.range[1]
                            })
                        }
                        if (!ruleValue) {
                            if (input) {
                                input.querySelector('.ant-calendar-picker-input.ant-input').style.borderColor = '#d90a04'
                            }
                            this.$message.error('请选择限期开课时间')
                            return
                        }
                        break;
                    default:
                        ruleValue = v.ruleValue
                }

                const json = {
                    id: v.id,
                    childCourseId: v.childCourseId,
                    ruleType: v.ruleType,
                    ruleValue: ruleValue
                }
                if (json.id === 0) {
                    delete json.id
                }
                arr.push(json)
            }
            this.openClassTableDataCache = JSON.stringify(this.openClassTableRelevant.tableDataSource)
            this.form.data.deblockRules = arr;
            if (type !== 1) {
                this.openClass.visible = false;
            }
        },
        //开课规则 - 弹框点击取消
        openClassModalCancel() {
            this.openClass.tableHeadRadioValue = 0
            this.openClassTableRelevant.tableDataSource = JSON.parse(this.openClassTableDataCache)
        },
        //开课规则 - 表头下拉框设置规则
        openClassTableRadioClick(clearFilters) {
            clearFilters()
            for (let i = 0; i < this.openClassTableRelevant.tableDataSource.length; i++) {
                this.openClassTableRelevant.tableDataSource[i].ruleType = this.openClass.tableHeadRadioValue
            }
        },
        //开课规则 - 表格下拉框设置规则
        openClassSettingSelectChange(value) {
            if ([2, 3, 5].includes(value.ruleType)) {
                this.openClassTableRelevant.tableDataSource[value.index].ruleValue = value.ruleValue
            } else {
                this.openClassTableRelevant.tableDataSource[value.index].ruleValue = ''
            }
        },

        //保存
        preserveAndOut(next) {
            this.$refs.stepsFirstRuleForm.validate(valid => {
                if (valid) {
                    const json = {
                        organizationId: this.courseInfo.organizationId,
                        projectCourseResourceId: this.form.data.projectCourseResourceId,
                        name: this.form.data.name,
                        description: this.form.data.description,
                        codeType: this.form.data.codeType,
                        effectiveDate: this.form.data.effectiveDate,
                        uneffectiveDate: this.form.data.uneffectiveDate,
                        deblockRules: this.form.data.deblockRules
                    }
                    if (this.courseInfo) {
                        json.projectCourseConfigId = this.courseInfo.id
                    }
                    if (next === 1) {
                        this.buttonLoading.next = true
                    } else {
                        this.buttonLoading.prev = true
                    }
                    // this.$http.post(Apis.ConfigCourse, json).then(({ status, data, message }) => {
                    this.$http.Course.addCourseConfigCourse(json).then(res => {
                        const {data, message} = res;
                        if (next === 1) {
                            this.preserveFormData(data)
                            this.$emit('steps', 1)
                        } else {
                            this.$message.success(message);
                            this.$store.commit("course/setEditCourse", null);
                            setTimeout(() => {
                                document.querySelector(".tabs-head .ant-tabs-tab-active .icon-close").click();
                                this.$router.push("/projectImpl/organizationDetails");
                            }, 500)
                        }
                    }).finally(() => {
                      this.buttonLoading.prev = false
                      this.buttonLoading.next = false
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        //保存页面数据
        preserveFormData(id) {
            const json = {
                id: id,
                complete: this.complete,
                courseResourceName: this.form.data.projectCourseResourceName,
                projectCourseResourceId: this.form.data.projectCourseResourceId,
                courseId: this.form.data.courseId,
                productServiceId: this.form.data.assessType,
                assessTypeStatus: this.form.data.assessTypeStatus,
                productServiceName: this.form.data.assessTypeName,
                name: this.form.data.name,
                codeType: this.form.data.codeType,
                description: this.form.data.description,
                effectiveDate: this.form.data.effectiveDate,
                uneffectiveDate: this.form.data.uneffectiveDate
            }
            if (this.courseInfo) {
                json.courseResourceIsLimitUser = this.courseInfo.courseResourceIsLimitUser
                json.courseResourceMaxUserCount = this.courseInfo.courseResourceMaxUserCount
                json.courseResourceConfigUserCount = this.courseInfo.courseResourceConfigUserCount
                json.configuredUserCount = this.courseInfo.configuredUserCount
            } else {
                const courseResource = JSON.parse(sessionStorage.getItem('StepsFirstCourseResource'))
                json.courseResourceIsLimitUser = courseResource.isLimitUser
                json.courseResourceMaxUserCount = courseResource.maxUserCount
                json.courseResourceConfigUserCount = courseResource.configUserCount
            }
            this.$store.commit('course/setEditCourse', json)
        },

        effectiveDateChange(val) {
            this.form.data.uneffectiveDate = undefined
        },
        uneffectiveDateChange(val){
            if(new Date(val).getTime() < new Date(this.form.data.effectiveDate).getTime()){
                this.form.data.uneffectiveDate = undefined
                this.$message.warning('结束时间小于开始时间，请重新选择');
            }
        },
        closepicker(val){
            if(!val){
                if(new Date(this.form.data.uneffectiveDate).getTime() < new Date(this.form.data.effectiveDate).getTime()){
                    this.form.data.uneffectiveDate = undefined
                    this.$message.warning('结束时间小于开始时间，请重新选择');
                }
            }
        }
    }
}
</script>

<style scoped>
#StepsFirst {
    width: 500px;
    margin: 0 auto;
}

.disabled {
    pointer-events: none;
}

#StepsFirst .access-resources >>> .ant-input[disabled] {
    color: rgba(0, 0, 0, 0.65);
    background-color: #fff;
    cursor: default;
}

.serach-item {
    width: 205px;
    margin-bottom: 15px;
}

.setting-btn {
    background-color: #E6A23C;
    border-color: #E6A23C;
    padding: 0 25px;
    font-size: 14px;
    border-radius: 5px;
    color: #fff;
}

.openClass-tableHead-radio {
    display: block;
    height: 30px;
    line-height: 30px;
}

.content-box {
    padding: 20px;
    overflow: hidden;
}

.content-box .resourcesItemActive {
    border: 1px solid rgba(24, 144, 255, 0.6);
    box-shadow: 0 2px 12px 0 rgba(24, 144, 255, 0.3);
}

.content-box .resourcesItem:hover {
    border: 1px solid rgba(24, 144, 255, 0.6);
    box-shadow: 0 2px 12px 0 rgba(24, 144, 255, 0.3);
}

#StepsFirst .access-resources .pointer {
    pointer-events: none;
    cursor: pointer;
}
</style>
